var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "35px",
    viewBox: "0 0 27 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-docx") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 34.5681485 26.8244942 34.5681485 26.8244942 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-docx"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1431597,8.06316832 L21.7967757,8.06316832 L19.372006,8.06316832 C18.9957727,8.06316832 18.6906716,7.76064357 18.6906716,7.38777228 L18.6906716,0.675396039 C18.6906716,0.673316831 18.6906716,0.671584158 18.6906716,0.66950495 L18.6906716,0 L0.681334481,0 C0.305101162,0 0,0.302524752 0,0.675396039 L0,33.8924753 C0,34.2656931 0.305101162,34.5682179 0.681334481,34.5682179 L26.1431597,34.5682179 C26.519393,34.5682179 26.8244942,34.2656931 26.8244942,33.8924753 L26.8244942,8.06316832 L26.1431597,8.06316832 Z",
    id: "Fill-1",
    fill: "#156DA8",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#0C3D5E",
    fillRule: "nonzero",
    points: "20.0534451 0.395707742 20.0534451 6.71234141 26.4253521 6.71234141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.290000, 24.170000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41452726,0.84670842 L2.72764392,0.84670842 L2.72764392,5.54 L1.68688333,5.54 L1.68688333,0.84670842 L0,0.84670842 L0,0 L4.41452726,0 L4.41452726,0.84670842 Z M9.69267688,5.54 L8.65578529,5.54 C8.5835743,5.54 8.52553933,5.52213101 8.48168036,5.48636238 C8.44042136,5.45059375 8.40690036,5.40973721 8.3810864,5.36376211 L7.08497191,3.23741368 C7.06435789,3.30125777 7.03984391,3.35618269 7.01146094,3.40215779 L5.76951243,5.36376211 C5.73856044,5.40719326 5.70247042,5.4480498 5.66118047,5.48636238 C5.62249049,5.52213101 5.57092447,5.54 5.50642053,5.54 L4.53530192,5.54 L6.39242118,2.68954373 L4.60881289,0 L5.64570448,0 C5.71794642,0 5.76951243,0.010216587 5.80046442,0.030650374 C5.83401637,0.0485285583 5.86496836,0.0791786258 5.89332038,0.122600576 L7.16622088,2.15316755 C7.19203484,2.08931426 7.22298682,2.02545791 7.25907684,1.96160462 L8.42751438,0.141756869 C8.45589735,0.0932286167 8.48684934,0.057469183 8.52037034,0.0344816324 C8.5539223,0.0114937753 8.59648128,0 8.64804729,0 L9.6423799,0 L7.84329561,2.64739988 L9.69267688,5.54 Z M14.2457143,0.84670842 L12.558831,0.84670842 L12.558831,5.54 L11.5180704,5.54 L11.5180704,0.84670842 L9.83118703,0.84670842 L9.83118703,0 L14.2457143,0 L14.2457143,0.84670842 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTxt);
export default __webpack_public_path__ + "static/media/icon-txt.ae6fdd17d6887ca016055572f905170f.svg";
export { ForwardRef as ReactComponent };